import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../utils/date_utils";
import CustomModal from "../../components/UiComponent/Modal";
import RegisterTaskReportForm from "./RgisterTaskReport";
import UpdateTaskReportForm from "./updateTaskReport";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import BasicTable from "../../components/UiComponent/customTable";
import { GetUserInfo, hasAccess } from "../../utils/permissionChecker";
import { GrView, GrStatusGoodSmall } from "react-icons/gr";
import {
  get_my_task,
  get_branch_tasks,
  get_my_task_status,
} from "../../services/employeeApi";
import Card from "../../components/Card";

const MyTaskLists = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const emp_id = user.employee.id;
  const user_branch = user?.employee?.branch_id;
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [reportupdateData, setupdateReportData] = useState();
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const handleUpdateShowModal = () => setShowUpdateModal(true);
  const handleUpdateCloseModal = () => setShowUpdateModal(false);
  const handleupdateButtonSubmit = () => {
    handleUpdateCloseModal();
  };
  const [reportData, setReportData] = useState();
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleButtonSubmit = () => {
    handleCloseModal();
  };

  const { data, isLoading, isError, error } = useQuery(
    ["employee_task_dashboard", emp_id, user_branch],
    async () => {
      const [myTaskStatus, myTaskData, branchTaskData] = await Promise.all([
        get_my_task_status(emp_id),
        get_my_task(emp_id),
        get_branch_tasks(user_branch),
      ]);

      return {
        myTaskStatus,
        myTaskData,
        branchTaskData,
      };
    },
    {
      enabled: !!emp_id && !!user_branch,
      keepPreviousData: true,
    }
  );
  const branchTasks = useMemo(() => {
    const list = data?.branchTaskData?.data;

    if (!Array.isArray(list)) return [];

    return Array.from(
      new Map(list.map((task) => [task.task_id, task])).values()
    );
  }, [data?.branchTaskData]);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (isError) {
    return <div>Error: {error.message}</div>;
  }
  console.log("====================");
  console.log(data);
  const myTaskStatus = data?.myTaskStatus || {};
  const myTasks = data?.myTaskData || [];

  const roleName = user?.role?.name;
  const isAdmin = roleName === "administrator";
  const isManager = roleName === "manager";
  const addnewReport = (event, data) => {
    event.preventDefault();
    const newData = {
      ...data,
      employee_id: emp_id,
    };
    setReportData(newData);
    handleShowModal();
  };

  const addMassReport = (event, data) => {
    event.preventDefault();
    const task = {
      ...data,
      employee_id: emp_id,
    };
    history.push("/register-task-report", { taskData: task });
  };

  const updateReport = (event, data) => {
    event.preventDefault();
    setupdateReportData(data);
    handleUpdateShowModal();
  };

  const handleViewMyReport = (myTasks) => {
    history.push("/my-task-status", { myTasks });
  };

  const myTaskColimns = [
    {
      header: "task_name",
      accessorFn: (row) => `${row.task_title}`,
    },
    {
      header: "date",
      accessorKey: "date",
    },
    {
      header: "Branche",
      accessorKey: "branch_name",
    },

    {
      header: "quantity",
      accessorKey: "quantity",
    },
    {
      header: "amount",
      accessorKey: "amount_birr",
    },
    {
      header: "status",
      accessorKey: "status",
      cell: ({ row }) => {
        const task = row.original;
        const status = task.status;
        let badgeClass = "bg-secondary";
        if (status === "pending") badgeClass = "bg-warning text-dark";
        if (status === "approved") badgeClass = "bg-success";
        if (status === "rejected") badgeClass = "bg-danger";
        if (status === "canceled") badgeClass = "bg-secondary";
        return (
          <div className="d-flex flex-column gap-2">
            <span className={`badge ${badgeClass}`}>{status}</span>
            {status === "approved" ? (
              <span className="text-success"></span>
            ) : (
              <Button
                variant="info"
                size="sm"
                onClick={(e) => updateReport(e, task)}
              >
                {t("update")}
              </Button>
            )}
          </div>
        );
      },
    },
  ];

  const myTasksLists = data?.myTaskData?.tasks || [];
  return (
    <div>
      <div className="container mt-4">
        <h6 className="mb-4">Tasks List</h6>
        <div className="row">
          {(isAdmin || isManager) &&
            branchTasks.map((task) => (
              <div className="col-md-3 mb-4" key={task.id}>
                <Card className="shadow-sm h-80">
                  <Card.Header>
                    <span className="badge bg-info">{task.task_name}</span>
                  </Card.Header>

                  <Card.Body>
                    <p>
                      <strong>Working Area:</strong> {task.branch_name}
                    </p>
                    <p>
                      <strong>Task Details:</strong> {task.task_description}
                    </p>
                  </Card.Body>

                  <Card.Footer>
                    <div className="d-flex justify-content-between mt-3">
                      {hasAccess(
                        ["administrator", "manager"],
                        user.accessRole
                      ) && (
                        <Button
                          variant="success"
                          size="sm"
                          onClick={(e) => addMassReport(e, task)}
                        >
                          {t("group_submit")}
                        </Button>
                      )}

                      <Button
                        variant="info"
                        size="sm"
                        onClick={() => handleViewMyReport(task.id)}
                      >
                        {t("report")}
                      </Button>
                    </div>

                    <small className="text-muted">
                      Assigned on:{" "}
                      {new Date(task.createdAt).toLocaleDateString()}
                    </small>
                  </Card.Footer>
                </Card>
              </div>
            ))}
        </div>

        <div className="row">
          {!(isAdmin || isManager) &&
            myTasksLists.map((task) => (
              <div className="col-md-3 mb-4" key={task.id}>
                <Card className="shadow-sm h-80">
                  <Card.Header>
                    <span className="badge bg-info">{task.task_name}</span>
                  </Card.Header>

                  <Card.Body>
                    <p>
                      <strong>Working Area:</strong> {task.branch_name}
                    </p>
                    <p>
                      <strong>Task Details:</strong> {task.task_description}
                    </p>
                  </Card.Body>

                  <Card.Footer>
                    <div className="d-flex justify-content-between mt-3">
                      <Button
                        variant="success"
                        size="sm"
                        onClick={(e) => addnewReport(e, task)}
                      >
                        {t("submit")}
                      </Button>
                      <Button
                        variant="info"
                        size="sm"
                        onClick={() => handleViewMyReport(task.id)}
                      >
                        {t("report")}
                      </Button>
                    </div>

                    <small className="text-muted">
                      Assigned on:{" "}
                      {new Date(task.createdAt).toLocaleDateString()}
                    </small>
                  </Card.Footer>
                </Card>
              </div>
            ))}
        </div>
      </div>

      <BasicTable
        data={data?.myTaskStatus?.data}
        columns={myTaskColimns}
        title={`Recent Submissions`}
      />

      <CustomModal
        show={showModal}
        title="task_report_form"
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <RegisterTaskReportForm
            onSubmitButton={handleButtonSubmit}
            reportData={reportData}
          />
        }
      />

      <CustomModal
        show={showUpdateModal}
        title="update_task_report_form"
        onHide={handleUpdateCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <UpdateTaskReportForm
            onSubmitButton={handleupdateButtonSubmit}
            reportUpdateData={reportupdateData}
          />
        }
      />
    </div>
  );
};
export default MyTaskLists;
